<template>
  <div>
    <div v-if="loading" style="font-size:1rem;color:#9e9e9e;text-align:center;margin-top:11rem;">
      <LoadingText />
    </div>
    <div v-else style="margin-top:0.6rem;padding:0 0.2rem;">
      <v-row no-gutters style="margin-top:1.25rem;">
        <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
          <span class="us-icon"><i class="fa fa-building-o"  aria-hidden="true" style="margin-right:0.1rem;" /></span>
          <span>团队</span>
        </v-col>
        <v-col cols="8">
          <span v-if="curCompanyInfo">{{curCompanyInfo.COMPANY_NAME}}</span>
        </v-col>
      </v-row>
      <!-- <div style="margin-bottom:0.84rem;"><PriorityLabel :value="detailInfo.GZ_PRIORITY" noStyle size="large" /></div> -->
      <v-row no-gutters style="margin-top:1.2rem;">
        <v-col cols="4" style="padding-left:0.2rem;padding-top: 0.5rem;" class="us-label">
          <span class="us-icon"><i class="fa fa-circle-o-notch" aria-hidden="true" style="margin-right:0.5rem;" /></span>
          <span>优先级</span>
        </v-col>
        <v-col cols="8">
          <div><PriorityLabel :value="detailInfo.GZ_PRIORITY" noStyle size="large" /></div>
        </v-col>
      </v-row>
      <v-row no-gutters style="margin-top:1.2rem;">
          <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
          <span class="us-icon"><i class="fa fa-hashtag" aria-hidden="true" style="margin-right:0.5rem;" /></span>
          <span>标题</span>
          </v-col>
          <v-col cols="8" style="font-size: 1.1rem;">
          {{detailInfo.GZ_TITLE}}
          </v-col>
      </v-row>
      <v-row no-gutters style="margin-top:0.7rem;">
          <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
              <span class="us-icon"><i class="fa fa-align-left" aria-hidden="true" style="margin-right:0.5rem;" /></span>
              <span>内容</span>
          </v-col>
          <v-col cols="8" style="font-size: 1.1rem;">
            {{ (detailInfo.GZ_CONTENT && detailInfo.GZ_CONTENT !=='') ? detailInfo.GZ_CONTENT : '&lt;空&gt;' }}
          </v-col>
      </v-row>
      <!-- <v-row no-gutters style="margin-top:0.3rem;">
          <v-col cols="12" style="text-indent:1.71em;line-height:1.5rem;">
              {{ (detailInfo.GZ_CONTENT && detailInfo.GZ_CONTENT !=='') ? detailInfo.GZ_CONTENT : '&lt;空&gt;' }}
          </v-col>
      </v-row> -->
      <div style="margin-top:0.2rem;">
          <viewer :images="pictures">
          <v-row style="margin:0;">
              <v-col  v-for="(pt,index) in pictures" :key="index" cols="4" style="padding:6px;margin-top:0.29rem;">
              <div style="width:100px;height:100px;">
                  <img
                  :src="pt.PICTURE_THUMB_URL"
                  :data-original="pt.PICTURE_URL"
                  onError='this.src="/res/default_img.jpg";this.onerror=null;'
                  alt="A"
                  class="img-rounded"
                  style="width:100%;height:100%;border-radius:5px;" />
              </div>
              </v-col>
          </v-row>
          </viewer>
      </div>
      <v-row no-gutters style="margin-top:1rem;">
          <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
          <span class="us-icon"><i class="fa fa-file-code-o" aria-hidden="true" style="margin-right:0.5rem;" /></span>
          <span>单号</span>
          </v-col>
          <v-col cols="8">
          {{detailInfo.GZ_ORDER_CODE}}
          </v-col>
      </v-row>
      <v-row no-gutters style="margin-top:0.8rem;">
          <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
          <span class="us-icon"><i class="fa fa-calendar-plus-o" aria-hidden="true" style="margin-right:0.4rem;" /></span>
          <span>创建时间</span>
          </v-col>
          <v-col cols="8">
          {{$moment(detailInfo.ROW_DATE_CREATE).format("YYYY-MM-DD HH:mm:ss")}}
          </v-col>
      </v-row>
      <v-row no-gutters style="margin-top:0.8rem;">
          <v-col cols="4" style="padding-left:0.2rem;" class="us-label">
          <span class="us-icon"><i class="fa fa-caret-square-o-down" aria-hidden="true" style="font-size:1.1rem;margin-right:0.5rem;" /></span>
          <span>状态</span>
          </v-col>
          <v-col cols="8">
          <GzBizSidLabel :value="detailInfo.BIZ_SID" />
          </v-col>
      </v-row>
      <div style="margin-top:3rem;text-align:center;">
          <div v-if="detailInfo.BIZ_SID < 4">
          <!-- <div><v-btn large color="success" style="width:50%;font-weight:bold;" @click="joinOrder" :disabled="joinDisabled" >同意加入</v-btn></div>
          <div><v-btn large color="#f2f2f2" style="width:50%;margin-top:1.1rem;color:#4caf50;font-weight:bold;" :disabled="joinDisabled" @click="rejectJoin" >拒绝加入</v-btn></div> -->
          <div>
            <v-btn large class="secondary us-btn-style" @click="joinOrder" :disabled="joinDisabled" >同意加入</v-btn>
          </div>
          <div>
            <v-btn large color="error" class="us-btn-style" :disabled="joinDisabled" @click="rejectJoin" >拒绝加入</v-btn>
          </div>
          </div>
          <div v-else style="color:#606266;font-size:1rem;">已经完成了, 不能参与加入.</div>
      </div>
    </div>
  </div>
</template>

<script>
import PriorityLabel from '../../../components/PriorityLabelV2'
import LoadingText from '../../../components/LoadingText'
import GzBizSidLabel from '../../../components/GzBizSidLabel'
export default {
  components: { PriorityLabel, LoadingText, GzBizSidLabel },
  props: {
    companyInfo: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      detailInfo: {
        GZ_TITLE: '模拟测试故障-无法连接网络',
        GZ_CONTENT: '',
        GZ_ORDER_CODE: '20200701001',
        ROW_DATE_CREATE: '2020-07-01 20:13:42',
        GZ_DATE_TIME: '2020-07-01 20:07:34',
        GZ_PRIORITY: 2,
        GZ_REMARK: '',
        BIZ_SID: 0
      },
      pictures: [],
      curOrderLink: 'http://www.baidu.com?test=123',
      orderCode: '',
      joinDisabled: false,
      loading: true
    }
  },
  computed: {
    curCompanyInfo: {
      get() {
        return this.companyInfo
      },
      set(val) {
        this.$emit('update:companyInfo', val)
      }
    }
  },
  mounted() {
    var that = this
    that.orderCode = that.$route.params.code
    that.initData()
  },
  created() {
  },
  methods: {
    getDuration(from, to) {
      var text = this.$moment(from).from(to)
      text = text.replace('前', '')
      return text
    },
    initData() {
      var that = this
      that.$api.bz.queryOrderDetail({ order_code: that.orderCode }).then(res => {
        // console.log('queryOrderDetail.res', res);
        if (!res.success) {
          that.loading = false
          // that.$toast.warning('获取故障信息失败');
          console.log('获取故障信息失败', res);
          return;
        }
        var data = res.data
        that.detailInfo = data.order
        that.curCompanyInfo = data.company
        that.pictures = data.pictures
        // console.log('that.companyInfo', that.curCompanyInfo);
        that.loading = false
      })
    },
    joinOrder() {
      var that = this
      that.$api.bz.joinOrder({ order_code: that.orderCode }).then(res => {
        if (!res.success) {
          that.$toast.warning(res.error_msg);
          return;
        }
        that.joinDisabled = true
        that.$router.goActionResPage({ tag: 1, text: '加入成功', auto_ret: 'b' })
      })
    },
    rejectJoin() {
      var that = this
      that.$router.goActionResPage({ tag: 0, text: '已拒绝加入', auto_ret: 'a' })
    }
  }
}
</script>

<style scoped>
.us-v-content{
  overflow:auto !important;
  overflow-x:hidden !important;
  /* min-height: 200px !important; */
}

.us-icon{
  width: 30px;
  max-width: 30px;
  display: inline-block;
  text-align: center !important;
}

.us-icon i{
  font-size: 1rem;
}

.us-v-rating >>> .v-icon{
  padding: 0.1rem !important;
}

.us-label{
  color: #9b9b9b;

}
.secondary {
    background-color: #5cbbf6 !important;
    border-color: #5cbbf6 !important;
}
.us-btn-style {
  font-size: 16px;
  width: 90%;
  font-weight: bold;
  margin-top: 1.1rem;
  text-align: center;
}
</style>

